import React from "react"
import {findDOMNode} from "react-dom"

// @ts-ignore
import Popover from "../../../../../gd-components/gd-popover/popover"

import FieldRAG_Icon from "../rag-icon"

export default function FieldRAG_Popover(props:any) {
    return (
        <Popover className          = "fl-ac p-t-10 p-r-10 p-b-10 p-l-10"
                 attachment         = "top center"
                 targetAttachment   = "bottom center"
                 getTargetFunc      = {()=>findDOMNode(props.parent)}
                 onClickOutside     = {()=>{props.parent.hidePopover()}}>
            {_.map(props.field.options, (option, key)=>{
                if (option.excludeFromSelectable) return null

                return (
                    <FieldRAG_Icon key          = {key}
                                   className    = "m-r-4 m-l-4 lh-20"
                                   option       = {option}
                                   onClick      = {option=>props.parent.onOptionClick(option)}/>
                )
            })}
        </Popover>
    )
}